module.exports = __webpack_public_path__ + "static/media/greenhouse.2e2bace5.svg";